{
    "sign_in": "Sign in",
    "sign_out": "Sign out",
    "title": "Sign in to your account",
    "subtitle": "Use your Bank credentials to continue.",
    "identifier": "Email address or employee ID",
    "identifier_placeholder": "name@developmentbank.om",
    "password": "Password",
    "remember": "Keep me signed in",
    "forgot": "Forgotten your password?",
    "submit": "Sign in",
    "signing_in": "Signing in…",
    "demo_heading": "Demo personas",
    "demo_description": "Select a role to sign in instantly. Available in demo mode only.",
    "demo_password_note": "All demo accounts use the password {{password}}.",
    "session_expired_title": "Your session ended",
    "session_expired_body": "You were signed out after a period of inactivity. Sign in again to continue where you left off.",
    "two_factor_title": "Two-factor authentication",
    "two_factor_body": "Enter the six-digit code from your authenticator app.",
    "two_factor_code": "Authentication code",
    "two_factor_recovery": "Use a recovery code instead",
    "password_expired_title": "Your password has expired",
    "password_expired_body": "Choose a new password to continue.",
    "current_password": "Current password",
    "new_password": "New password",
    "confirm_password": "Confirm new password",
    "welcome_back": "Welcome back"
}
